import {memo, useState} from "react";
import Input, {InputAttributes} from "../Input";
import RippleButton from "../RippleButton";
import Eye from "@/icons/eye.svg?react";
import EyeOff from "@/icons/eye-off.svg?react";

const PasswordInput = (props: InputAttributes) => {
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);

  return (
    <div className="relative w-full">
      <Input type={isVisiblePassword ? "text" : "password"} {...props} />
      <div className="absolute top-[13px] right-4">
        <RippleButton
          variant="icon"
          onClick={() => setIsVisiblePassword(!isVisiblePassword)}
        >
          {isVisiblePassword ? <Eye /> : <EyeOff />}
        </RippleButton>
      </div>
    </div>
  );
};

export default memo(PasswordInput);
